<template>
  <layout :session="session" :participant="participant">
    <div
      class="mt-12 px-4 py-5 flex flex-col items-center justify-center w-full"
    >
      <div class="mt-6 px-4 py-5 text-center">
        <h1 class="text-3xl sm:text-question-large font-extralight">
          {{ translations.question }} {{ currentQuestion }} /
          {{ questionsData.length }}
        </h1>
      </div>

      <div class="px-4 py-5 text-center w-full sm:w-8/12 mr-auto ml-auto">
        <div
          v-for="option in profileOptions"
          :key="option.id"
          class="flex items-center mb-2"
        >
          <div
            class="w-2/12 px-4 h-14 sm:px-6 flex flex-col bg-gray-200 rounded-md justify-center text-center mr-2 shadow"
          >
            {{ enumerate(option) }}
          </div>
          <div
            class="w-10/12 pl-2 pr-1 h-14 sm:px-6 flex  rounded-md  bg-white text-left shadow border-2"
            :class="highlight(option)"
          >
            <div class="w-full flex flex-col justify-center">
            {{ option.terms }}
            </div>

            <div class="px-2 sm:px-3 whitespace-nowrap flex items-center justify-between space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              @click="setPlus(option)"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 shrink-0 cursor-pointer"
              :class="plusClass(option)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          
            <svg
              xmlns="http://www.w3.org/2000/svg"
              @click="setMinus(option)"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 shrink-0 cursor-pointer"
              :class="minusClass(option)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          </div>

          
        </div>
      </div>

      <div
        class="flex justify-evenly px-4 py-5 text-center w-full sm:w-8/12 mr-auto ml-auto"
      >
        <button
          @click="approve(1)"
          :disabled="!optionsSelected"
          class="inline-flex items-center px-2 py-2 mr-2 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none transition duration-150 ease-in-out uppercase whitespace-nowrap"
          :class="approvalClasses(1)"
        >
          {{ translations.fully_agree }}
        </button>

        <button
          @click="approve(2)"
          :disabled="!optionsSelected"
          class="inline-flex items-center px-2 py-2 mr-2 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none transition duration-150 ease-in-out uppercase whitespace-nowrap"
          :class="approvalClasses(2)"
        >
          {{ translations.agree }}
        </button>

        <button
          @click="approve(3)"
          :disabled="!optionsSelected"
          class="inline-flex items-center px-2 py-2 mr-2 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none transition duration-150 ease-in-out uppercase whitespace-nowrap"
          :class="approvalClasses(3)"
        >
          {{ translations.no_but_go_along }}
        </button>

        <button
          @click="approve(4)"
          :disabled="!optionsSelected"
          class="inline-flex items-center px-2 py-2 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none transition duration-150 ease-in-out uppercase whitespace-nowrap"
          :class="approvalClasses(4)"
        >
          {{ translations.veto }}
        </button>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/Live/Shared/Layout';

export default {
  name: 'ProfileIndex',

  components: {
    Layout,
  },

  props: [
    'session',
    'participant',
    'profileQuestions',
    'profileApproval',
    'profileRating',
    'translations',
  ],

  data() {
    return {
      currentQuestion: this.session.current_profile_question,
      questionsData: this.profileQuestions,
      approval: this.profileApproval,
      plus: this.profileRating.plus ?? null,
      minus: this.profileRating.minus ?? null,
    };
  },

  computed: {
    profileOptions() {
      return this.questionsData[this.currentQuestion - 1].options;
    },
    optionsSelected() {
      return this.profileOptions.filter((item) => item.choice).length > 0;
    },
  },

  mounted() {
    Echo.channel(
      'markencode-app.session.' + this.participant.markencode_session.id
    ).listen('.profile-question.answered', (option) => {

      console.log('.profile-question.answered');

      this.questionsData[this.currentQuestion - 1].options.map((item) => {
        if (option.minus == item.id) {
          this.$set(item, 'choice', 'minus');
        } else if (option.plus == item.id) {
          this.$set(item, 'choice', 'plus');
        } else {
          this.$set(item, 'choice', '');
        }

        this.approval = null;
      });
    });
  },

  destroyed() {
    // console.log('leaving profile component');
    // Echo.leave('markencode-app.session.' + this.participant.markencode_session.id);
  },

  methods: {
    enumerate(option) {
      let letters = ['A', 'B', 'C', 'D'];

      return `${letters[option.id - 1]}.`;
    },

    highlight(option) {
      console.log(option);
      if (option.choice == 'plus') {
        return 'border-markencode-green';
      }

      if (option.choice == 'minus') {
        return 'border-markencode-red';
      }

      return 'border-transparent';
    },

    approvalClasses(approval) {
      
      if (!this.optionsSelected) {
        return 'text-white bg-gray-200 cursor-default';
      }

      if(this.approval == 1 && this.approval == approval) {
        return 'text-white bg-markencode-green cursor-default';
      }

      if(this.approval == 2 && this.approval == approval) {
        return 'bg-markencode-light-green cursor-default';
      }

      if(this.approval == 3 && this.approval == approval) {
        return 'bg-markencode-yellow cursor-default';
      }

      if(this.approval == 4 && this.approval == approval) {
        return 'text-white bg-markencode-red cursor-default';
      }
      
      return 'text-gray-500 bg-gray-200 cursor-pointer';

    },

    approve(choice) {
      this.approval = choice;

      window.axios.post(
        this.route('live.profile.approval.store', {
          uuid: this.participant.uuid,
        }),
        {
          approvalRating: this.approval,
        }
      );
    },

    plusClass(option) {
      if(this.plus && this.plus == option.id) {
        return 'text-markencode-green';
      }
      
      return 'text-gray-600';
    },

    minusClass(option) {
      if(this.minus && this.minus == option.id) {
        return 'text-markencode-red';
      }
      
      return 'text-gray-600';
    },

    setPlus(option) {
      this.plus = option.id;

      if(this.minus && this.minus == option.id) {
        this.minus = null;
      }

      window.axios.post(
        this.route('live.profile.rate', {
          uuid: this.participant.uuid,
        }),
        {
          plus: this.plus || null,
          minus: this.minus || null,
        }
      );
    },

    setMinus(option) {
      this.minus = option.id;

      if(this.plus && this.plus == option.id) {
        this.plus = null;
      }

      window.axios.post(
        this.route('live.profile.rate', {
          uuid: this.participant.uuid,
        }),
        {
          plus: this.plus || null,
          minus: this.minus || null,
        }
      );
    },
  },
};
</script>